module.exports = __webpack_public_path__ + "img/chef_recommended.39db4285.svg";